import { render, staticRenderFns } from "./projectReport.vue?vue&type=template&id=43c04653&scoped=true&"
import script from "./projectReport.vue?vue&type=script&lang=js&"
export * from "./projectReport.vue?vue&type=script&lang=js&"
import style0 from "./projectReport.vue?vue&type=style&index=0&id=43c04653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c04653",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c04653')) {
      api.createRecord('43c04653', component.options)
    } else {
      api.reload('43c04653', component.options)
    }
    module.hot.accept("./projectReport.vue?vue&type=template&id=43c04653&scoped=true&", function () {
      api.rerender('43c04653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/projectReport.vue"
export default component.exports